export default __webpack_public_path__ + "static/media/bug.b79c6d9d.svg";